<div class="container-fluid py-5">
  <!-- For demo purpose -->
  <div class="row mb-4">
    <div class="col-lg-8 mx-auto text-center">
      <h1 class="display-6 "> Group Education Session</h1>
    </div>
  </div> <!-- End -->

  <div class="row">
    <div class="col-lg-12 mx-auto ">
      <mat-card>
        <form role="form" [formGroup]="form">
          <div class="row">
            <!*--------------------------------------------- Centre Name --------------------------------------------->

            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
              <mat-label>Centre Name</mat-label>
              <mat-select (selectionChange)="onCentreSelect($event)" required [formControl]="centreSelect"
                          multiple #CentreSelect="matSelect" >
                <mat-option *ngFor="let  c of (centres$|async)"
                            [value]="c">{{c.centreName}} </mat-option>


                <mat-select-trigger>
  <span *ngIf="CentreSelect.value?.length; else noParticipantSelection">
    {{ CentreSelect.value[0]?.centreName | slice:0:16 }}
    {{ CentreSelect.value[0]?.centreName?.length > 16 ? '...' : '' }}

    <span *ngIf="CentreSelect.value.length > 1" class="textcol">
      (+{{ CentreSelect.value.length - 1 }} more)
    </span>
  </span>

                  <ng-template #noParticipantSelection>
                    Select Centre...
                  </ng-template>
                </mat-select-trigger>

              </mat-select>
              <mat-error *ngIf=" CenterName?.invalid  &&  (CenterName?.touched || CenterName?.dirty)">
                <mat-error style="color: red;" *ngIf="CenterName?.errors?.required">*Centre Name is
                  Required.
                </mat-error>
                <mat-error style="color: red;" *ngIf="CenterName?.errors?.pattern">*Enter Only
                  characters.
                </mat-error>
              </mat-error>
            </mat-form-field>


            <!*--------------------------------------------- Name Of Child
            --------------------------------------------->
            <mat-form-field appearance="outline" class="col-md-6 col-sm-12"  >
              <mat-label>Name of the Students</mat-label>
              <mat-select #select aria-label="Default select example"
                          (selectionChange)="onChildSelect($event)"
                          multiple  #ChildSelect="matSelect">
                <app-select-all [matSelect]="select"></app-select-all>
                <mat-option *ngFor="let c of (children$ | async)" (click)="optionClick()"
                            [value]="c">
<!--                  {{c.firstName}} {{c.lastName}} ({{c.age}})-->
                  <div class="option-row">
                    <span class="child-name">{{ c.firstName }} {{ c.lastName }} </span>
                    <span class="child-age"> → Age: {{ c.age }}</span>
                  </div>
                </mat-option>

                <mat-select-trigger>
  <span *ngIf="ChildSelect.value?.length; else noSelection">

    <!-- Display first child's name + age -->
    {{ ChildSelect.value[0]?.firstName }} {{ ChildSelect.value[0]?.lastName }}
    → Age: {{ ChildSelect.value[0]?.age }}

    <!-- Show +X more -->
    <span *ngIf="ChildSelect.value.length > 1" class="textcol">
      (+{{ ChildSelect.value.length - 1 }} more)
    </span>
  </span>

                  <ng-template #noSelection>
                    Select Student...
                  </ng-template>
                </mat-select-trigger>



              </mat-select>

            </mat-form-field>


            <!*-- Type of Session--->
            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
              <mat-label>Type of session</mat-label>
              <mat-select formControlName="sessionType" required>
                <mat-option value="Regular Study "> Regular Study</mat-option>
                <mat-option value="Activity Session">Activity Session</mat-option>
                <mat-option value="Special Day">Special Day</mat-option>
              </mat-select>
              <mat-error
                *ngIf=" form.controls.sessionType?.invalid  &&  (form.controls.sessionType?.touched || form.controls.sessionType?.dirty)">
                <mat-error style="color: red;" *ngIf="form.controls.sessionType?.errors?.required">*It
                  is Required.
                </mat-error>
                <mat-error style="color: red;" *ngIf="form.controls.sessionType?.errors?.pattern">*Enter
                  Only characters.
                </mat-error>
              </mat-error>
            </mat-form-field>

            <!*---------------------------------------------Gender--------------------------------------------->
            <!--                        <mat-form-field appearance="outline" class="col-md-6 col-sm-12">-->
            <!--                            <mat-label>Select gender</mat-label>-->
            <!--                            <mat-select   formControlName="gender" >-->

            <!--                                <mat-option  value="Male">Male</mat-option>-->
            <!--                                <mat-option  value="Female">Female</mat-option>-->
            <!--                            </mat-select>-->
            <!--                            <mat-error *ngIf=" form.controls.gender?.invalid  &&  (form.controls.gender?.touched || form.controls.gender?.dirty)">-->
            <!--                                <mat-error style="color: red;" *ngIf="form.controls.gender?.errors?.required">*It is Required.</mat-error>-->
            <!--                                <mat-error style="color: red;" *ngIf="form.controls.gender?.errors?.pattern">*Enter Only characters.</mat-error>-->
            <!--                            </mat-error>-->
            <!--                        </mat-form-field>-->

            <!--                        <mat-form-field *ngIf="form.controls.present.value=='Absent'" appearance="outline"-->
            <!--                                        class="col-md-6 col-sm-12">-->
            <!--                            <mat-label>Reason</mat-label>-->
            <!--                            <mat-select formControlName="absentReason">-->
            <!--                                <mat-option value="Hospitalised">Hospitalised</mat-option>-->
            <!--                                <mat-option value="In the center, but unwell">In the center, but unwell</mat-option>-->
            <!--                                <mat-option value="Hospital visit">Hospital visit</mat-option>-->
            <!--                                <mat-option value="Event at the center">Event at the center</mat-option>-->
            <!--                                <mat-option value="Others">Others</mat-option>-->
            <!--                                <mat-option value="NA">NA</mat-option>-->
            <!--                            </mat-select>-->

            <!--                            <mat-error-->
            <!--                                    *ngIf=" form.controls.absentReason?.invalid && form.controls.absentReason.value!=null  &&  (form.controls.absentReason?.touched || form.controls.absentReason?.dirty)">-->
            <!--                                <mat-error style="color: red;" *ngIf="form.controls.absentReason?.errors?.required">*It-->
            <!--                                    is Required.-->
            <!--                                </mat-error>-->
            <!--                                <mat-error style="color: red;" *ngIf="form.controls.absentReason?.errors?.pattern">-->
            <!--                                    *Enter Only characters.-->
            <!--                                </mat-error>-->
            <!--                            </mat-error>-->
            <!--                        </mat-form-field>-->


            <!--                        <mat-form-field *ngIf="form.controls.present.value=='Absent'" appearance="outline" class="col-md-6 col-sm-12">-->
            <!--                            <mat-label>Reason</mat-label>-->
            <!--                            <mat-select   formControlName="absentReason" >-->
            <!--                                <mat-option  value="Hospitalised">Hospitalised</mat-option>-->
            <!--                                <mat-option  value="Others">Others</mat-option>-->
            <!--                            </mat-select>-->
            <!--                            <mat-error *ngIf=" form.controls.absentReason?.invalid && form.controls.absentReason.value!=null  &&  (form.controls.absentReason?.touched || form.controls.absentReason?.dirty)">-->
            <!--                                <mat-error style="color: red;" *ngIf="form.controls.absentReason?.errors?.required">*It is Required.</mat-error>-->
            <!--                                <mat-error style="color: red;" *ngIf="form.controls.absentReason?.errors?.pattern">*Enter Only characters.</mat-error>-->
            <!--                            </mat-error>-->
            <!--                        </mat-form-field>-->


            <!*---------------------------------------------
            Subject--------------------------------------------->
            <mat-form-field appearance="outline" class="col-md-6 col-sm-12">
              <mat-label>Subject</mat-label>
              <mat-select aria-label="Default select example" formControlName="subject" multiple>
                <mat-option value="Language">Language</mat-option>
                <mat-option value="Math">Math</mat-option>
                <mat-option value="EVS">EVS/GK</mat-option>
                <mat-option value="Activity">Activity</mat-option>
                <mat-option value="NA">NA</mat-option>
              </mat-select>
              <mat-error
                *ngIf=" form.controls.subject?.invalid  &&  (form.controls.subject?.touched || form.controls.subject?.dirty)">
                <mat-error style="color: red;" *ngIf="form.controls.subject?.errors?.required">*It is
                  Required.
                </mat-error>
                <mat-error style="color: red;" *ngIf="form.controls.subject?.errors?.pattern">*Enter
                  Only characters.
                </mat-error>
              </mat-error>
            </mat-form-field>
            <!---->
            <!*---------------------------------------------
            DATE--------------------------------------------->
            <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
              <mat-label>Session conducted on</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="sessionDate" [max]="maxDate">
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error
                *ngIf=" form.controls.sessionDate?.invalid  &&  (form.controls.sessionDate?.touched || form.controls.sessionDate?.dirty)">
                <mat-error style="color: red;" *ngIf="form.controls.sessionDate?.errors?.required">*It
                  is Required.
                </mat-error>
                <mat-error style="color: red;" *ngIf="form.controls.sessionDate?.errors?.pattern">*Enter
                  Only characters.
                </mat-error>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
              <mat-label>Start Time</mat-label>
              <!-- The timepicker input -->
              <input matTimepicker #t="matTimepicker" formControlName="startTime" [value]="startTimeValue"
                     [strict]="false" id="timepicker-example" mode="12h"
                     placeholder="Please select time..." name="time">
              <!-- An icon for the timepicker input that will open the timepicker dialog when clicked -->
              <mat-icon matSuffix (click)="t.showDialog()">access_time</mat-icon>
              <!-- Error that will be shown when the input date is invalid -->
              <mat-error *ngIf="startTime?.touched && startTime?.invalid">Invalid Time</mat-error>

            </mat-form-field>


            <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
              <mat-label>End Time</mat-label>
              <!-- The timepicker input -->
              <input matTimepicker #t="matTimepicker" formControlName="endTime" [value]="endTimeValue"
                     [strict]="false" id="end-time-picker" mode="12h"
              >
              <!-- An icon for the timepicker input that will open the timepicker dialog when clicked -->
              <mat-icon matSuffix (click)="t.showDialog()">access_time</mat-icon>
              <!-- Error that will be shown when the input date is invalid -->
              <mat-error *ngIf="endTime?.touched && endTime?.invalid">Invalid Date</mat-error>
            </mat-form-field>


            <!---->

            <mat-form-field appearance="outline" class="col-md-12 col-sm-12">
              <mat-label data-toggle="tooltip">Topic covered in session</mat-label>
              <input type="text" matInput required formControlName="topicsCovered" (blur)="onBlur(form.controls.topicsCovered)">
              <mat-error
                *ngIf=" form.controls.topicsCovered?.invalid  &&  (form.controls.topicsCovered?.touched || form.controls.topicsCovered?.dirty)">
                <mat-error style="color: red;" *ngIf="form.controls.topicsCovered?.errors?.required">*It
                  is Required.
                </mat-error>
                <mat-error style="color: red;" *ngIf="form.controls.topicsCovered?.errors?.pattern">
                  *Enter Only characters.
                </mat-error>
              </mat-error>
            </mat-form-field>


            <mat-form-field appearance="outline" class="col-md-12 col-sm-12">
              <mat-label data-toggle="tooltip" title="">Session details</mat-label>
              <textarea matInput id="textAreaExample" rows="4"
                        formControlName="sessionDetails" (blur)="onBlur(form.controls.sessionDetails)"></textarea>
              <mat-error
                *ngIf=" form.controls.sessionDetails?.invalid  &&  (form.controls.sessionDetails?.touched || form.controls.sessionDetails?.dirty)">
                <mat-error style="color: red;" *ngIf="form.controls.sessionDetails?.errors?.required">
                  *It is Required.
                </mat-error>
                <mat-error style="color: red;" *ngIf="form.controls.sessionDetails?.errors?.pattern">
                  *Enter Only characters.
                </mat-error>
              </mat-error>
            </mat-form-field>

<!--            <mat-form-field appearance="outline" class="col-md-6 col-sm-6">-->
<!--              <mat-label data-toggle="tooltip" title="">Session details</mat-label>-->
<!--              <textarea matInput id="textAreaExample" rows="4"-->
<!--                        formControlName="remark" (blur)="onBlur(form.controls.sessionDetails)"></textarea>-->
<!--              <mat-error-->
<!--                *ngIf=" form.controls.sessionDetails?.invalid  &&  (form.controls.sessionDetails?.touched || form.controls.sessionDetails?.dirty)">-->
<!--                <mat-error style="color: red;" *ngIf="form.controls.sessionDetails?.errors?.required">-->
<!--                  *It is Required.-->
<!--                </mat-error>-->
<!--                <mat-error style="color: red;" *ngIf="form.controls.sessionDetails?.errors?.pattern">-->
<!--                  *Enter Only characters.-->
<!--                </mat-error>-->
<!--              </mat-error>-->
<!--            </mat-form-field>-->

<!--            <mat-form-field appearance="outline" class="col-md-12 col-sm-12">-->
<!--              <mat-label data-toggle="tooltip">Remark</mat-label>-->
<!--              <input type="text" matInput required formControlName="remark" (blur)="onBlur(form.controls.remark)">-->
<!--              <mat-error-->
<!--                *ngIf=" form.controls.remark?.invalid  &&  (form.controls.remark?.touched || form.controls.remark?.dirty)">-->
<!--                <mat-error style="color: red;" *ngIf="form.controls.remark?.errors?.required">*It is-->
<!--                  Required.-->
<!--                </mat-error>-->
<!--                <mat-error style="color: red;" *ngIf="form.controls.remark?.errors?.pattern">*Enter Only-->
<!--                  characters.-->
<!--                </mat-error>-->
<!--              </mat-error>-->
<!--            </mat-form-field>-->

                                <!--    Performance        -->
            <mat-form-field appearance="outline" class="col-md-12 col-sm-12">
              <mat-label data-toggle="tooltip">Performance</mat-label>
              <mat-select formControlName="remark">
                <mat-option value="Well Done"> Well Done</mat-option>
                <mat-option value="Very Good"> Very Good</mat-option>
                <mat-option value="Good"> Good</mat-option>
                <mat-option value="Fair"> Fair</mat-option>
                <mat-option value="Can do better"> Can do better</mat-option>
              </mat-select>

              <mat-error
                *ngIf=" form.controls.remark?.invalid  &&  (form.controls.remark?.touched || form.controls.remark?.dirty)">
                <mat-error style="color: red;" *ngIf="form.controls.remark?.errors?.required">*It is
                  Required.
                </mat-error>
                <mat-error style="color: red;" *ngIf="form.controls.remark?.errors?.pattern">*Enter Only
                  characters.
                </mat-error>
              </mat-error>
            </mat-form-field>



            <!----->

            <mat-form-field appearance="outline" class="col-md-6">
              <mat-label>Education session conducted by teacher</mat-label>
              <input matInput formControlName="submittedBy" >
              <mat-error
                *ngIf=" form.controls.submittedBy?.invalid  &&  (form.controls.submittedBy?.touched || form.controls.submittedBy?.dirty)">
                <mat-error style="color: red;" *ngIf="form.controls.submittedBy?.errors?.required">*It
                  is Required.
                </mat-error>
                <mat-error style="color: red;" *ngIf="form.controls.submittedBy?.errors?.pattern">*Enter
                  Only characters.
                </mat-error>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-md-4" >
              <mat-label>Conducted By</mat-label>
              <mat-select formControlName="conductedBy" (selectionChange)="OnConductedByChange($event)" >
                <mat-option value="By Teacher">By Teacher</mat-option>
                <mat-option value="By Volunteer">By Volunteer</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-md-4" *ngIf="showVolunteerName">
              <mat-label>Volunteer Name</mat-label>
              <mat-select formControlName="volunteerName"  >
                <mat-option *ngFor="let volunteer of mVolunteers$|async" [value]="volunteer">{{volunteer}}</mat-option>
<!--                <mat-error *ngIf="form.get('conductedBy')?.errors?.required && form.get('conductedBy')?.dirty">-->
<!--                  Conducted By is required.-->
<!--                </mat-error>-->
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="col-md-4" *ngIf="showVolunteerName" >
              <mat-label>Count As</mat-label>
              <mat-select formControlName="countType" >
                <mat-option  value="bychildren">Count per child</mat-option>
                <mat-option  value="bysession">Count per session</mat-option>

              </mat-select>
            </mat-form-field>
            <!*---------------------------------------------PRESENT TABLE--------------------------------------------->
            <div class="text-center">

              <table class="table tableFixHead" *ngIf="selectedChildrens.length>0">
                <thead>
                <tr>
                  <th scope="col"><strong>Child Name</strong></th>
<!--                  <th scope="col"><strong>Age</strong></th>-->
                  <th scope="col"><strong>Unit Code</strong></th>
                  <th scope="col"><strong>Gender</strong></th>
                  <th scope="col"><strong>Is Follow-up</strong></th>
                  <!--                        <th scope="col" ><strong>Centre Name</strong> </th>-->
<!--                  <th scope="col"><strong>Attendance</strong></th>-->
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let c of selectedChildrens;let i = index">
                  <td>{{c.childName}}</td>
<!--                  <td>{{c.age}}</td>-->
                  <td>{{c.unitCode}}</td>
                  <td>{{c.gender}}</td>
                  <!--                        <td  >{{c.centreName}}</td>-->
                  <td>{{c.isFollowUp}}
<!--                    <mat-form-field appearance="outline" class="no-padding">-->
<!--                      <mat-label>is Follow-up Child</mat-label>-->
<!--                      <mat-select (selectionChange)="isFollowUpChild(i ,$event.value,c)"-->
<!--                               [value]="c.isFollowUp"   >-->
<!--                        <mat-option value="Yes">Yes</mat-option>-->
<!--                        <mat-option value="No">No</mat-option>-->
<!--                      </mat-select>-->
<!--                    </mat-form-field>-->
                  </td>
<!--                  <td>-->
<!--                    <mat-form-field appearance="outline" class="no-padding">-->
<!--                      <mat-label>&#45;&#45;Select&#45;&#45;</mat-label>-->
<!--                      <mat-select (selectionChange)="AddPresent(i ,$event.value,c)"-->
<!--                                  value="Present">-->
<!--                        <mat-option value="Present">Present</mat-option>-->
<!--                        <mat-option value="NA">NA</mat-option>-->
<!--                        <mat-option value="Hospitalised">Hospitalised</mat-option>-->
<!--                        <mat-option value="Unwell">Unwell</mat-option>-->
<!--                        <mat-option value="Hospital Visit">Hospital Visit</mat-option>-->
<!--                        <mat-option value="Event at the Centre">Event at the Centre</mat-option>-->
<!--                      </mat-select>-->
<!--                    </mat-form-field>-->

<!--                    &nbsp;&nbsp;&nbsp;-->
<!--&lt;!&ndash;                    <button mat-mini-fab (click)="removeChild(i,c)" color="accent">-</button>&ndash;&gt;-->
<!--                  </td>-->
                </tr>
                </tbody>
              </table>
            </div>


            <!--                                            <prettyjson [obj]="userData"></prettyjson>-->
            <div class="col-4" *ngIf="formSaved">
              <app-upload [path]="docpath" [dbType]="dbType" [storagePath]="storagePath"></app-upload>
            </div>
            <div class="d-flex justify-content-center mt-3 mb-4 ">
              <button mat-raised-button color="primary" type="submit" class="btn btn-success"
                      (click)="Submit()">Save
              </button>&nbsp;&nbsp;
              <button mat-raised-button color="warn" type="button" (click)="close()" class="btn btn-danger">Cancel
              </button>
            </div>
          </div>

        </form>
        <!--                <prettyjson [obj]="form.getRawValue()"></prettyjson>-->
<!--        <prettyjson [obj]="selectedChildrens"></prettyjson>-->

      </mat-card>
    </div>
  </div>
</div>
